import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/configSlice";

import configApis from "src/api/config";

import { common } from "src/types/index";
import { constants } from "src/constants/common";

// get reminders saga
const GetRemindersSaga = function* GetRemindersSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      configApis.getReminders,
      payload
    );

    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.getRemindersSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.getRemindersError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

export default function* configSaga() {
  yield all([takeEvery(actions.getRemindersRequest, GetRemindersSaga)]);
}
